import React from "react";
import { buildVehicleImageCandidates, getVehicleSkeletonPath } from "../../utils/vehicleImage";

export default function VehicleImage({
  imageUrl,
  modelImage,
  brand,
  model,
  color,
  type,
  alt,
  className = "",
  wrapperClassName = "",
  allowSkeleton = true,
}) {
  const candidates = React.useMemo(
    () =>
      buildVehicleImageCandidates({
        imageUrl,
        modelImage,
        brand,
        model,
        color,
        type,
        allowSkeleton,
      }),
    [imageUrl, modelImage, brand, model, color, type, allowSkeleton]
  );

  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    setIndex(0);
  }, [imageUrl, modelImage, brand, model, color, type, allowSkeleton]);

  const currentSrc =
    candidates[index] ||
    (allowSkeleton ? getVehicleSkeletonPath(type) : "");

  if (!currentSrc) {
    return <div className={wrapperClassName} aria-hidden="true" />;
  }

  return (
    <div className={wrapperClassName}>
      <img
        src={currentSrc}
        alt={alt}
        className={className}
        loading="lazy"
        decoding="async"
        fetchpriority="low"
        onError={() => {
          if (index < candidates.length - 1) {
            setIndex((prev) => prev + 1);
          }
        }}
      />
    </div>
  );
}
